import React from 'react'
import { observer } from 'mobx-react'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function JobExtensionProgressionNotStartedActions({
  vm,
}: Props) {
  if (!vm.isAnyExtensionFlowAvailable) {
    return null
  }

  return <TaxExtensionProgressionActions vm={vm} />
})
